import { AiFillStar, AiOutlineStar } from "react-icons/ai"
import "../Styles/Component/ReviewCard.css"


const ReviewCard = ({data}) => {
    console.log(data)
    const rating = (num) => {
        const rate = Math.round(num) || 0
        return rate === 5 ?
        <div className="rating">
            <AiFillStar/>
            <AiFillStar/>
            <AiFillStar/>
            <AiFillStar/>
            <AiFillStar/>
        </div> : 
        rate === 4 ? 
        <div className="rating">
            <AiFillStar/>
            <AiFillStar/>
            <AiFillStar/>
            <AiFillStar/>
            <AiOutlineStar/>

        </div> : 
        rate === 3 ? 
        <div className="rating">
            <AiFillStar/>
            <AiFillStar/>
            <AiFillStar/>
            <AiOutlineStar/>
            <AiOutlineStar/>

        </div> : 
        rate === 2 ? 
        <div className="rating">
            <AiFillStar/>
            <AiFillStar/>
            <AiOutlineStar/>
            <AiOutlineStar/>
            <AiOutlineStar/>

        </div> : 
        <div className="rating">
            <AiFillStar/>
            <AiOutlineStar/>
            <AiOutlineStar/>
            <AiOutlineStar/>
            <AiOutlineStar/>

        </div>
    }

    return<>
        <div className="reviewCardWrapper">
            <img src="" alt="" />

            <div className="reviewCardDetails">
                <div className="rating">
                    {
                        rating(data.rating)
                    }
                </div>
                <div className="reviewCardHeading">
                    <h3>{data.user && data.user.name}</h3>
                    <span></span>
                    <p>{new Date(data.createdAt).toDateString()}</p>
                </div>
                <p className="info">{data.comment}</p>
            </div>
        </div>
    </>

}

export default ReviewCard